// Libs
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import { Action } from 'redux/types/Action';
// App
import { AutocompletePredictionWithDetails } from 'app-shared/lib/components/inputs/places-search-autocomplete';

/**
 * Interface definition for state
 */
interface State {
  place: AutocompletePredictionWithDetails;
  loginRedirectUrl: string;
}

/**
 * Type definition for state
 */
export type UserPreferencesState = Readonly<State>;

/**
 * Initial state definition
 */
const initialState: State = {
  place: null,
  loginRedirectUrl: null,
};

/**
 * Reducer definition
 */
const reducers = {
  setPlace: (state: State, action: Action<AutocompletePredictionWithDetails>) => {
    state.place = action.payload;
  },

  setLoginRedirectUrl: (state: State, action: Action<string>) => {
    state.loginRedirectUrl = action.payload;
  },
};

/**
 * Slice definition
 */
const userPreferencesSlice = createSlice({
  name: 'userPreferences',
  initialState,
  reducers,
});

/**
 * Extract user preferencesfrom root state
 * @param   {Object} state The root state
 * @returns {State} The user preferences
 */
export const selectUserPreferences = (state: Readonly<RootState>): State => state.userPreferences;

/**
 * Actions definition
 */
export const { setPlace, setLoginRedirectUrl } = userPreferencesSlice.actions;

export default userPreferencesSlice.reducer;
